import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
    selectedItem: ['dashboard'],
    drawerOpen: false,
    headerOpen: true
};

// ==============================|| SLICE - MENU ||============================== //

const menu = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        activeItem(state, action) {
            state.selectedItem = action.payload;
        },

        openDrawer(state, action) {
            state.drawerOpen = action.payload;
        },
        openHeader(state, action) {
            state.headerOpen = action.payload;
        }
    }
});

export default menu.reducer;

export const { activeItem, openDrawer, openHeader } = menu.actions;
